<template>
    <div class="proOption">
        <div
            class="btnGroup"
            v-for="({name, values, currId}, index) in attr_list"
            :key="name"
        >
            <span>{{name}}</span>
            <el-button-group>
                <el-button
                    v-for="({label, id},indexs) in values"
                    :key="id"
                    :class="{'chosen': currId===id}"
                    @click="handleChoose(index, id, attr_list,currId,name,values,indexs)"
                >
                    {{label}}
                </el-button>
            </el-button-group>
        </div>

        <div class="amount">
            <span>单价</span>
            <span ><el-input v-model="price" style="width: 100px;" @change="chaochu" ></el-input></span>
        </div>
        <div v-if="type===1" class="amount">
            <span>数量</span>
            <span>
                <el-input-number
                    v-model="qty"
                    size="small"
                    :min="1"
                    controls-position="right"
                    :step="1"></el-input-number>
            </span>
        </div>

        <div class="footer">
            <el-button  type="primary" @click="addProductt" :loading="btnLoading">确定
            </el-button>
            <el-button @click="$emit('update:visible', false)">取消</el-button>
        </div>
    </div>
</template>

<script>
    import { getPrice ,changeorder, orderList} from '../../stores/api';

    export default {
        //type 1:dialog, 2:popover
        props: ['type', 'list', 'visible', 'goods_attr_list', 'goods_attr_id',  'goods_id', 'product_id', 'order_id', 'goods_price', 'getCartProducts', 'rec_id', 'referer', 'qtyRaw', 'fang', 'goods_number', 'getOrderList', 'order_sn'],
        data () {
            return {
                btnLoading: false,
                price: 0,
                minprice: 0,
                maxprice: 0,
                repertory: 1,
                qty: 1,
                attr_list: this.list || [],
                labelt: [],
                namet: [],
                hbln: [],
                goods_count: 1,
                arrt: [],
                indexs:0,
            };
        },
        beforeMount () {
            this.getPrice();
        },
        created () {
          this.getindex()
        },
        methods: {
            getindex() {
                if (this.goods_attr_list[0].name === '匹数') {
                    this.xhindex = this.goods_attr_id.split(',')[1]
                    this.goods_attr_list[1].values.forEach((item, index) => {
                        if (this.xhindex === item.id) {
                            this.indexs = index
                        }
                    })
                    console.log(this.xhindex)
                } else if (this.goods_attr_list[0].name !== '匹数') {
                    this.xhindex = this.goods_attr_id.split(',')[0]
                    this.goods_attr_list[0].values.forEach((item, index) => {
                        if (this.xhindex === item.id) {
                            this.indexs = index
                        }
                    })
                }
            },
            handleChoose (index, id,attr_list,currId,name,label,indexs) {
                const spec = this.attr_list.map(item => item.currId);
                this.indexs = indexs
                if (this.attr_list[index].currId !== id) {
                    this.attr_list[index].currId = id;
                    this.arrt=this.attr_list[index].currId;
                    for(var i=0;i<this.attr_list.length;i++){
                        this.namet[i]=this.attr_list[i].name+':';
                        this.attr_list[i].values.forEach(item=>{
                            if(item.id === this.attr_list[i].currId) {
                                this.labelt[i]=item.label
                            }
                        })
                        // if(this.attr_list[0].name === '匹数'){
                        //     this.labelt[0]=this.attr_list[0].values[0].label;
                        // }else {
                        //     this.labelt[0]=this.attr_list[0].values[this.indexs].label;
                        // }
                        // if (this.attr_list[1]) {
                        //     if(this.attr_list[1].name === '匹数'){
                        //         this.labelt[1]=this.attr_list[1].values[0].label;
                        //     }else {
                        //         this.labelt[1]=this.attr_list[1].values[this.indexs].label;
                        //     }
                        // }
                        // if (this.attr_list[2]) {
                        //     if(this.attr_list[2].name === '遥控型号') {
                        //         this.labelt[2]=this.attr_list[2].values[0].label;
                        //     }else {
                        //         this.labelt[2]=this.attr_list[2].values[this.indexs].label;
                        //     }
                        // }
                    }
                    for (var j=0;j<this.namet.length;j++){
                        this.hbln[j] = this.namet[j].concat(this.labelt[j])
                    }
                    this.getPrice();
                }
            },
            chaochu(){
                if(Number(this.minprice)<=Number(this.price)&&Number(this.price)<=Number(this.maxprice)){
                    // console.log('chengg')
                    // console.log(this.product_id)
                } else{
                    // this.$message.error('价格超出定价范围')
                }
            },
            addProductt () {
                // this.btnLoading = true;
                const spec = this.attr_list.map(item => item.currId);
                let params = {
                    goods_id: this.goods_id,
                    goods_count: this.goods_count,
                    number: this.type === 2 ? this.qtyRaw : this.qty,
                    parant: 0,
                    spec,
                    goods_attr: this.hbln,
                    quick: spec.length === 0 ? 0 : 1,
                    rec_id: this.rec_id
                };
                this.goods_number = this.qty
                changeorder(this.hbln.toString(),this.goods_id, this.goods_number,  this.price, this.rec_id,this.product_id,this.order_id,spec.toString()).then(res => {
                    this.$notify.success({
                        title: '操作成功',
                        message: '修改商品成功!',
                    });
                    this.indexs = 0
                    this.attr_list = "";
                    this.btnLoading = false;
                    this.$emit('update:visible', false);
                    this.getOrderList()
                })
            },
            getPrice () {
                let attr = '';
                this.attr_list.forEach(item => {
                    attr += item.currId + ',';
                });
                getPrice({id: this.goods_id, attr}).then(res => {
                    this.product_id = res.data.product_id
                    this.price = Number(this.goods_price);
                    this.minprice = Number(res.data.result_no)
                    this.maxprice = Number(res.data.shop_price)
                    this.repertory = Number(res.data.product_number);
                });
            },
            getGtr() {
                this.qty = this.goods_number;
                for (let i=0; i<this.attr_list.length; i++) {
                    for (let j = 0; j < this.attr_list[i].values.length; j++) {
                        this.attr_list[i].cutId = this.attr_list[i].values[j].id
                        this.attr_list[i].label = this.attr_list[i].values[j].label
                        this.arrt[i] = this.attr_list[i].cutId
                    }
                }
                for (var i = 0; i < this.attr_list.length; i++) {
                    this.namet[i] = this.attr_list[i].name + ':';
                    this.attr_list[i].values.forEach(item => {
                        if (item.id === this.attr_list[i].currId) {
                            this.labelt[i] = item.label
                        }
                    })
                }
                for (var j = 0; j < this.namet.length; j++) {
                    this.hbln[j] = this.namet[j].concat(this.labelt[j])
                }
            }
        },
        watch: {
            list (val) {
                this.attr_list = val || [];
                this.getPrice();
            },
        },
        mounted() {
            this.getGtr()
        }
    };
</script>

<style lang="less" scoped>
    @import "../../default";

    .proOption {
        .btnGroup {
            display: flex;
            margin-bottom: 12px;
            & > span {
                flex: 0.2;
                line-height: 2;
                font-size: 14px;
            }
            .el-button-group {
                flex: 0.8;
                button {
                    min-width: 75px;
                    height: 30px;
                    margin-right: 8px;
                    margin-bottom: 8px;
                    padding: 0 10px;
                    background: #ffffff;
                    border-radius: 0;
                    border: 1px solid #dfe4ed;
                    font-size: 14px;
                    color: #1f2329;
                    &:hover {
                        .chosen;
                    }
                    img {
                        width: 20px;
                        height: 20px;
                        margin-right: 8px;
                        vertical-align: middle;
                    }
                }
                .chosen {
                    border-color: @orange;
                }
            }
        }
        .amount {
            display: flex;
            align-items: center;
            margin-bottom: 12px;
            & > span:nth-child(1) {
                flex: 0.2;
                line-height: 2;
            }
            & > span:nth-child(2) {
                flex: 0.8;
                color: #9ca2ad;
                text-align: left;
                /deep/ .el-input-number {
                    width: 75px;
                    .el-input-number__increase, .el-input-number__decrease {
                        width: 20px;
                    }
                    .el-input input {
                        color: @font_black;
                        padding: 0 30px 0 10px;
                        border-radius: 0;
                    }
                }
                & > span {
                    margin-left: 16px;
                }
            }
        }
        .footer {
            margin-top: 20px;
            padding-left: 78px;
        }

    }
</style>



// WEBPACK FOOTER //
// src/components/OrderList/ProOptionst.vue